import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { ActionIconCheckmark } from '@bubble-ui/icon-action-checkmark';
import { IconError } from '@bubble-ui/icon-error';
import { IconInformation } from '@bubble-ui/icon-information';
import { Loader } from '@bubble-ui/molecule-loader';
import { Text } from '@bubble-ui/primitive-text';
import { Typography } from '@bubble-ui/molecule-typography';
import { View } from '@bubble-ui/primitive-view';
import { getDisplayName } from '@bubble-ui/util-get-display-name';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import { defaultComponentTokens } from '../defaultComponentTokens';
import { isBigBullet } from '../helpers';
import { StepperItemWrapper } from '../StepperItemWrapper';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var StepperItem = _ref => {
  var {
    'aria-label': ariaLabel,
    bulletBackgroundColorToken = 'stepper/bullet-background-color',
    bulletBackgroundColorTokenArgs,
    bulletContentColorToken = 'stepper/bullet-content-color',
    bulletContentColorTokenArgs,
    children,
    customBulletContent,
    description,
    isLast,
    lineColorToken = 'stepper/line-color',
    lineColorTokenArgs,
    lineState,
    lineStyle = 'solid',
    noStartPadding,
    state = 'default',
    title,
    UNSAFE_props
  } = _ref;
  var designContext = useDesignContext(defaultComponentTokens);
  var {
    bulletAndLineWrapperStyle,
    bulletContentTextStyle,
    bulletStyle,
    contentWrapperStyle,
    customContentWrapperStyle,
    descriptionStyle,
    lineContainerStyle,
    loaderWrapperStyle,
    titleStyle,
    wrapperStyle
  } = getDefaultStyleSheet({
    bulletBackgroundColorToken,
    bulletBackgroundColorTokenArgs,
    bulletContentColorToken,
    bulletContentColorTokenArgs,
    customBulletContent,
    designContext,
    description,
    isLast,
    lineColorToken,
    lineColorTokenArgs,
    lineState: lineState || (state === 'disabled' ? 'disabled' : state === 'done' ? 'done' : 'default'),
    lineStyle,
    noStartPadding,
    state,
    title
  });
  var getBulletContent = () => {
    if (!isBigBullet({
      customBulletContent,
      state
    })) {
      return null;
    }
    var bulletContentProps = {
      colorToken: bulletContentColorToken,
      colorTokenArgs: _objectSpread({
        state
      }, bulletContentColorTokenArgs)
    };
    if (customBulletContent) {
      var _getDisplayName;
      if (['number', 'string'].includes(typeof customBulletContent)) {
        return /*#__PURE__*/React.createElement(Text, {
          style: bulletContentTextStyle
        }, customBulletContent);
      }
      if (/*#__PURE__*/React.isValidElement(customBulletContent) && (_getDisplayName = getDisplayName(customBulletContent)) !== null && _getDisplayName !== void 0 && _getDisplayName.startsWith('ActionIcon')) {
        return /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
          context: designContext
        }, /*#__PURE__*/React.cloneElement(customBulletContent, bulletContentProps));
      }
      return customBulletContent;
    }
    switch (state) {
      case 'done':
        return /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
          context: designContext
        }, /*#__PURE__*/React.createElement(ActionIconCheckmark, bulletContentProps));
      case 'error':
        return /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
          context: designContext
        }, /*#__PURE__*/React.createElement(IconError, bulletContentProps));
      case 'warning':
        return /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
          context: designContext
        }, /*#__PURE__*/React.createElement(IconInformation, bulletContentProps));
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement(StepperItemWrapper, _extends({}, UNSAFE_props, {
    "aria-disabled": state === 'disabled' || undefined,
    "aria-label": ariaLabel,
    style: wrapperStyle
  }), /*#__PURE__*/React.createElement(View, {
    style: bulletAndLineWrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    style: bulletStyle
  }, getBulletContent()), state === 'loading' && /*#__PURE__*/React.createElement(View, {
    style: loaderWrapperStyle
  }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(Loader, {
    UNSAFE_size: designContext.get('stepper/bullet-size', {
      bulletSize: 'big'
    }).value(),
    UNSAFE_strokeWidth: 2,
    UNSAFE_colorToken: "stepper/bullet-loader-color"
  }))), !isLast && /*#__PURE__*/React.createElement(View, {
    style: lineContainerStyle
  })), /*#__PURE__*/React.createElement(View, {
    style: contentWrapperStyle
  }, title && /*#__PURE__*/React.createElement(Text, {
    style: titleStyle
  }, title), description && /*#__PURE__*/React.createElement(View, {
    style: descriptionStyle
  }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(Typography, {
    textToken: "stepper/description-text-style",
    colorToken: "stepper/description-text-color",
    colorTokenArgs: {
      state
    }
  }, description))), children && /*#__PURE__*/React.createElement(View, {
    style: customContentWrapperStyle
  }, children)));
};
StepperItem.displayName = 'Stepper.Item';
export { StepperItem };
//# sourceMappingURL=index.js.map